import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef } from 'react';

interface Options {
  condition?: boolean;
}

export default <T extends HTMLElement>({ condition = true }: Options = {}) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const { current } = ref;

    if (!current) return;
    if (!condition) return;

    disableBodyScroll(current);

    return () => {
      enableBodyScroll(current);
    };
  }, [condition]);

  return ref;
};
